import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Contacts/ContactsModels';
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_RouteContact {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openRouteContactCreatePanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
     
        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Route/RouteContactCreateView', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create modal
            Utilities.GetModal('#routeContactCreateModal', ModalAction.Create);

            $('#routeContactCreate_NewContactBtn').on('click', function () {
                Utilities.GetModal('#routeContactCreateModal', ModalAction.Hide);
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, function (contacts: Array<ICAMSContact>) {
                    Utilities.GetModal('#routeContactCreateModal', ModalAction.Show);
                    $('#routeContactCreateModal [name="ContactRef"]').val(contacts[0].ContactRef);
                    $('#routeContactCreateModal [name="ContactListName"]').val(contacts[0].ListName);
                    self.loadAffiliationsLUTs(contacts[0].ContactRef, $('#routeContactCreateModal [name="ContactType"]'));
                }]));
            });

            // Get form validation
            Utilities.InitFormValidation($("#routeContactCreateModal"));

            $('#routeContactCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submitForm();
            });

            function submitForm() {
                // Validate
                let form: any = $('#routeContactCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>$('#routeContactCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/AddContactLink',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Contact added!');
                                Utilities.GetModal('#routeContactCreateModal', ModalAction.Hide);
                                callback();
                            }
                            else {
                                toastr.error('Failed to add contact!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#routeContactCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeContactCreateModal', ModalAction.Hide);
                callback();
            });

            $('#routeContactCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#routeContactCreateModal', ModalAction.Hide);
                callback();
            });
        });
      
    }

    public openRouteContactEditPanel = (ID: number, callback: Function): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Route/RouteContactEditView', { ID: ID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Edit modal
            Utilities.GetModal('#routeContactEditModal', ModalAction.Create);

            $('#routeContactEdit_NewContactBtn').on('click', function () {
                Utilities.GetModal('#routeContactEditModal', ModalAction.Hide);
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, function (contacts: Array<ICAMSContact>) {
                    Utilities.GetModal('#routeContactEditModal', ModalAction.Show);
                    $('#routeContactEditModal [name="ContactRef"]').val(contacts[0].ContactRef);
                    $('#routeContactEditModal [name="ContactListName"]').val(contacts[0].ListName);
                    self.loadAffiliationsLUTs(contacts[0].ContactRef, $('#routeContactEditModal [name="ContactType"]'));
                }]));
            });

            // Get form validation
            Utilities.InitFormValidation($("#routeContactEditModal"));

            $('#routeContactEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submitForm();
            });

            function submitForm() {
                // Validate
                let form: any = $('#routeContactEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>$('#routeContactEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/UpdateContactLink',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Contact update!');
                                Utilities.GetModal('#routeContactEditModal', ModalAction.Hide);
                                callback();
                            }
                            else {
                                toastr.error('Failed to update contact!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#routeContactEditDeleteBtn').on('click', function (evt) {
                self.deleteContact(ID, callback);
            });

            $('#routeContactEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeContactEditModal', ModalAction.Hide);
                callback();
            });

            $('#routeContactEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#routeContactEditModal', ModalAction.Hide);
                callback();
            });
        });

    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteContact = (ID: number, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Route/DeleteContactLink', {ID: ID},
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            Utilities.GetModal('#routeContactEditModal', ModalAction.Hide);
                            callback();
                        }
                        else {
                            if (result.message != null) toastr.error(result.message);
                            else toastr.error('Failed to delete feature!');
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private loadAffiliationsLUTs = (contactRef: string, el: JQuery<HTMLElement>): void => {
        const self = this;
        $.post('/Contact/GetAffiliationsForContact', { contactRef: contactRef },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        el.find('option').remove().end();
                        result.data.forEach(i => {
                            el.append($("<option></option>").attr("value", i.value).text(i.text));
                        });
                    }
                    else {
                        if (result.message != null) toastr.error(result.message);
                        else toastr.error('Failed to get affiliations!');
                    }
                }
                catch (err) {
                    console.log(err);
                    toastr.error('Error getting affiliations!');
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




